<template>
  <WdsStack direction-row align-start gap-sm>
    <WdsIcon
      v-if="countryCode || !noIconFallback"
      :size="16"
      :name="countryCode ? computeFlagIcon(countryCode) : WdsIconNameEnum.MAP"
      class="tw-flex-shrink-0 tw-mt-0.5"
    />
    <WdsText
      primary
      :xs="xs"
      class="tw-whitespace-nowrap"
      :title="title"
      :data-test="countryDataTest ?? `${dataTest}-country`"
    >
      {{ country }}
      <template v-if="detail" #subText>
        <span :data-test="detailDataTest ?? `${dataTest}-detail`">{{ detail }}</span>
      </template>
    </WdsText>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'
import { computeFlagIcon } from '@/utils/ts-tools'

// An empty detail renders nothing: a dash only belongs next to a fixed label.
withDefaults(
  defineProps<{
    country: string
    countryCode?: string | null
    detail?: string | null
    title?: string
    xs?: boolean
    noIconFallback?: boolean
    dataTest?: string
    countryDataTest?: string
    detailDataTest?: string
  }>(),
  {
    countryCode: null,
    detail: undefined,
    title: undefined,
    xs: false,
    noIconFallback: false,
    dataTest: 'location',
    countryDataTest: undefined,
    detailDataTest: undefined,
  },
)
</script>
